// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
}

body {
  margin: 0;
  font-family: "Unilever Shilling", sans-serif, -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overscroll-behavior-y: none;
}

code {
  font-family: "Unilever Shilling", source-code-pro, Menlo, Monaco, Consolas,
    "Courier New", monospace;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ReactModal__Overlay{
  background-color: rgba(0, 0, 0, 0.5) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT;;0DAEwD;EACxD,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;4BAC0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["html {\n  overscroll-behavior-y: none;\n  overscroll-behavior-x: none;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Unilever Shilling\", sans-serif, -apple-system,\n    BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\",\n    \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\" !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overscroll-behavior-y: none;\n}\n\ncode {\n  font-family: \"Unilever Shilling\", source-code-pro, Menlo, Monaco, Consolas,\n    \"Courier New\", monospace;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.ReactModal__Overlay{\n  background-color: rgba(0, 0, 0, 0.5) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
